import React from 'react';
import { Icon } from '.';

export const IconExpandMore = props => {
  return (
    <Icon
      {...props}
      aria-label="An arrow pointing up, usually used to indicate a section can be expanded."
    >
      <svg height="24" viewBox="0 0 24 24" width="24">
        <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
        <path d="M0 0h24v24H0z" fill="none" />
      </svg>
    </Icon>
  );
};
